import React, { Component } from 'react'
import { connect } from 'react-redux';
import { setFilter } from '../../actions/filters'
import getParams from '../utilities/getParams'

// Single input UI
const SingleInput = ({ value, input1HandleChange, label, setRef }) => (
    <React.Fragment>
        <input type="text"
            ref={node => { setRef(node) }}
            className="form-control"
            placeholder={`Search ${label}`}
            onChange={input1HandleChange}
            value={value}
        />
    </React.Fragment>
)

// Actual class
class NumericFilter extends Component {
    constructor(props) {
        super(props)
        this.state = {
            input1: '.*'
        }
        this.input1HandleChange = this.input1HandleChange.bind(this)
        this.clearFilter = this.clearFilter.bind(this)
        this.mainInput = HTMLInputElement

    }

    changeCallback() {
        // since we are setting the main input value programatically, we need to trigger onChange
        // event manually so Formik can save the changed value

        let actualValue = this.state.input1
        let nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set
        nativeInputValueSetter.call(this.mainInput, actualValue)

        var ev2 = new Event('input', { bubbles: true })
        this.mainInput.dispatchEvent(ev2)
    }

    clearFilter() {
        this.setState({
            input1: '.*'
        }, this.changeCallback)
    }

    input1HandleChange(event) {
        let txt = event.target.value
        this.setState({
            input1: txt === '' ? '.*' : txt
        })
    }

    componentDidUpdate() {
        this.bindToState()
    }
    componentDidMount() {
        const params = getParams(this.props.location && this.props.location.search ? this.props.location.search : "")
        const getTaskId = params.task_id;

        const getProps = this.props
        const getPreviousValue = this.props.value1.toString()

        this.setState({
            input1: getTaskId ? ".*" : getPreviousValue
        })

    }

    bindToState() {
        let filter = {}
        filter[this.props.filterName] = {
            type: "string",
            value1: this.state.input1
        }
        if (this.props.exact) {
            filter[this.props.filterName].exact = this.props.exact
        }
        if (this.props.label) {
            filter[this.props.filterName].label = this.props.label
        }

        this.props.dispatch(setFilter(
            this.props.id,
            filter
        ))
    }

    render() {
        let i1 = this.props.value1
        let bv = i1 === '.*' ? '' : i1
        let lb = this.props.label || this.props.filterName
        return (
            <span style={{ paddingRight: '5px' }}>
                <SingleInput
                    setRef={(node) => { this.mainInput = node }}
                    label={lb}
                    value={bv}
                    input1HandleChange={this.input1HandleChange}
                />
            </span>
        )
    }
}

export default connect(null, null, null, { withRef: true })(NumericFilter)


// WEBPACK FOOTER //
// ./src/components/filters/textFilter.js